import repository from './repsitory'

const resource = '/product'

export default {
    get () {
        return repository.get(`${resource}`)
    },
    getSkuFP () {
        return repository.get(`${resource}/sku`)
    },
    getSyncFP () {
        return repository.get(`${resource}/syncProducts`)
    },
    getSyncStockFP () {
        return repository.get(`${resource}/syncStockProducts`)
    },
    getById (id) {
        return repository.get(`${resource}/${id}`)
    },
    getByIdBase64Images (id) {
      return repository.get(`${resource}/edit/${id}`)
  },
    addProduct (data) {
        return repository.post(`${resource}`, data)
    },
    updateProduct (data, id) {
        return repository.put(`${resource}/${id}`, data)
    },
     getProductFilteredDashboard (data) {
        return repository.post(`${resource}/filterDashboard`, data)
    },
}
